// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Constants
import { CHART_TYPE_DEFAULT } from 'ChartApp/ts/features/charts-shared/constants';
// Actions
import { setFundChartType } from 'ChartApp/ts/apps/fund-chart/state/reducers/chart-type/chart-type.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const chartType = createReducer(CHART_TYPE_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.chartType), on(setFundChartType, (state, action) => action.chartType));
